import React, { useState } from "react";
import { Modal, Slider, SliderSingleProps } from "antd";
import { IconContainer, Label, SliderContainer } from "./styles";
import { GradeModalProps } from "./types";
import { FcIdea } from "react-icons/fc";
import Typography from "../../../../../../../../components/Typography";
import { Column } from "../../../../../../../../themes/globalStyle";
import Button from "../../../../../../../../components/Button";
import ThemeColors from "../../../../../../../../themes/colors";

const GradeModal: React.FC<GradeModalProps> = ({
  modalOpen,
  setQuestionModal,
  onSelectGrade,
}): JSX.Element => {
  const [selectedGrade, setSelectedGrade] = useState<string>();

  const marks: SliderSingleProps["marks"] = {
    0: {
      label: (
        <Label>
          <Typography
            text="Pouca prioridade"
            size="small"
            color="Black500"
            weight={400}
          />
        </Label>
      ),
    },
    10: {
      label: (
        <Label>
          <Typography
            text="Alta prioridade"
            size="small"
            color="Black500"
            weight={400}
          />
        </Label>
      ),
    },
  };

  return (
    <Modal
      destroyOnClose
      title={
        <Typography
          text="Grau de Importância"
          size="large"
          color="Black500"
          weight={600}
        />
      }
      width={"50%"}
      open={modalOpen}
      onOk={() => null}
      onCancel={() => setQuestionModal(false)}
      footer={
        <>
          {selectedGrade ? (
            <Button
              size="middle"
              borderRadius="0.5rem"
              style={{ width: "fit-content" }}
              backgroundColor={ThemeColors.Black500}
              onClick={() => onSelectGrade(selectedGrade)}
            >
              <Typography
                text="Criar objetivo"
                size="medium"
                color="Bg300"
                weight={400}
              />
            </Button>
          ) : (
            <Button
              size="middle"
              borderRadius="0.5rem"
              style={{ width: "fit-content" }}
              backgroundColor={ThemeColors.Black200}
              disabled
            >
              <Typography
                text="Deslize para definir"
                size="medium"
                color="Bg300"
                weight={400}
              />
            </Button>
          )}
        </>
      }
    >
      <Column style={{ marginTop: "1rem" }}>
        <Typography
          text="Ajuste o foco da sua estratégia ao indicar o que realmente importa"
          size="medium"
          color="Black400"
          weight={400}
        />
        <IconContainer>
          <FcIdea size={22} />
          <Typography
            text="Lembre-se: priorizar é essencial. Se tudo for prioridade, nada será."
            size="small"
            color="Black400"
            weight={300}
          />
        </IconContainer>
        <SliderContainer>
          <Slider
            step={1}
            max={10}
            min={0}
            marks={marks}
            onChange={(value) => setSelectedGrade(value.toString())}
          />
        </SliderContainer>
      </Column>
    </Modal>
  );
};

export default GradeModal;
